var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 11",
    width: 16,
    height: 11,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #415364 } \n\t\t.shp1 { fill: none;stroke: #415364;stroke-width: 1.5 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11337",
    className: "shp0",
    d: "M5.33 11L6.54 9.79L2.43 5.67L6.54 1.56L5.33 0.35L0 5.67L5.33 11Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Linha_651",
    className: "shp1",
    d: "M2.15 5.67L16 5.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectLeft);
export default __webpack_public_path__ + "static/media/select-left.8bd0ab23e6fd7a20b4be902e50c85deb.svg";
export { ForwardRef as ReactComponent };